import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';


const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.primary,
        textAlign: 'center',
        display: 'block'
    },
    menu: {
        color: '#222222',
        lineHeight: '50px',
        fontSize: '17px',
        textDecoration: "none",
    }
});

const MobileNav = (props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <hr />
            <Typography color="inherit"><span className={classes.menu}>Settings</span></Typography>
            <Typography color="inherit" onClick={() => {
                props.deleteToken();
            }}><Link to="/admin" className={classes.menu}>Logout</Link></Typography>
        </div>
    );
}

MobileNav.prototype = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(MobileNav);